module.exports = __webpack_public_path__ + "img/icon_961.d4497561.svg";